import { render } from "./EstateAgentReviewRatingGraph.vue?vue&type=template&id=ba664c9a&ts=true"
import script from "./EstateAgentReviewRatingGraph.vue?vue&type=script&lang=ts"
export * from "./EstateAgentReviewRatingGraph.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__